import React from 'react';
import {SelectContainerStyles, SelectStyles} from "../styles/Select";
import PropTypes from 'prop-types';

const Select = React.forwardRef(({ label, children, errorMessage, ...attrs }, ref) => {
    return (
        <SelectContainerStyles>
            {label && <label>{label}</label>}
            <SelectStyles {...attrs} ref={ref}>
                {children}
            </SelectStyles>
            {errorMessage && <span role="alert">{errorMessage}</span>}
        </SelectContainerStyles>
    );
});

Select.displayName = 'Select';

Select.propTypes = {
    label: PropTypes.string,
    children: PropTypes.node,
    errorMessage: PropTypes.string,
};

export default Select;